var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.15C5.4736 3.15 5.9278 3.33437 6.26269 3.66256C6.59758 3.99075 6.78571 4.43587 6.78571 4.9C6.78571 5.12981 6.73953 5.35738 6.64979 5.5697C6.56004 5.78202 6.42851 5.97493 6.26269 6.13744C6.09687 6.29994 5.90002 6.42884 5.68336 6.51679C5.46671 6.60473 5.2345 6.65 5 6.65C4.5264 6.65 4.0722 6.46563 3.73731 6.13744C3.40242 5.80925 3.21429 5.36413 3.21429 4.9C3.21429 4.43587 3.40242 3.99075 3.73731 3.66256C4.0722 3.33437 4.5264 3.15 5 3.15ZM5 0C6.32608 0 7.59785 0.516248 8.53553 1.43518C9.47322 2.3541 10 3.60044 10 4.9C10 8.575 5 14 5 14C5 14 0 8.575 0 4.9C0 3.60044 0.526784 2.3541 1.46447 1.43518C2.40215 0.516248 3.67392 0 5 0ZM5 1.4C4.0528 1.4 3.14439 1.76875 2.47462 2.42513C1.80485 3.0815 1.42857 3.97174 1.42857 4.9C1.42857 5.6 1.42857 7 5 11.697C8.57143 7 8.57143 5.6 8.57143 4.9C8.57143 3.97174 8.19515 3.0815 7.52538 2.42513C6.85561 1.76875 5.9472 1.4 5 1.4Z",
    fill: "#F26722"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location.13e47a93d1c0f2379edfbd3fafdc756b.svg";